<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="m-4 mx-1 mt-4">
      <h2 class="font-weight-bold">{{ $t("subcategory") }}</h2>
      <div>
        <v-btn
          color="warning"
          dark
          class="mx-2"
          :to="'/dashboard/products/add'"
        >
          {{ $t("add_product") }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          color="warning"
          dark
          :to="
            '/dashboard/categories/' + $route.params.id + '/subcategories/add'
          "
        >
          {{ $t("add_subcategory") }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          :label="$t('filter_by_subcategory')"
          outlined
          dense
          v-model="filter"
          @input="fetchSubcategories"
        />
      </v-col>
    </v-row>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="subcategories"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        :footer-props="{ 'items-per-page-options': [10, 20, 50], 'items-per-page-text': $t('rows_per_page') }"
        class="elevation-1"
        @update:page="fetchSubcategories"
        @update:items-per-page="fetchSubcategories"
      >
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
            {{ $t("pagination", { start: pageStart, end: pageStop, total: itemsLength }) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a
            class="blue--text text--darken-2"
            @click.prevent="viewSubcategory(item)"
          >
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.addedBy="{ item }">
          {{ item.addedby.name }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :to="`/dashboard/products?id=${item.id}`"
              >
                <v-list-item-title>{{
                  $t("view_products")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :to="`/dashboard/categories/${$route.params.id}/subcategories/update/${item.id}`"
              >
                <v-list-item-title>{{
                  $t("update_subcategory")
                }}</v-list-item-title>
              </v-list-item>
              
              <v-list-item @click="deleteSubcategory(item)">
                <v-list-item-title>{{
                  $t("delete_subcategory")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <delete-modal v-model="deleteDialog" @confirm="confirmDelete" />
  </v-container>
</template>

<script>
import api from "../services/axios";
import DeleteModal from "../components/DeleteModal.vue";
export default {
  components: {
    DeleteModal,
  },
  data() {
    return {
      deleteDialog: false,
      selectedItem: null,
      filter: "",
      loading: false,
      totalItems: 0,
      subcategories: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  watch: {
    "pagination.page": "fetchSubcategories",
    "pagination.itemsPerPage": "fetchSubcategories",
  },
  computed: {
    headers() {
      return [
        { text: this.$t("id"), value: "id" },
        { text: this.$t("subcategory"), value: "name" },
        { text: this.$t("added_date"), value: "created_at" },
        { text: this.$t("added_by"), value: "addedBy" },
        { text: "", value: "actions", sortable: false, align: "right" },
      ];
    },
  },

  mounted() {
    this.fetchSubcategories();
  },
  methods: {
    async fetchSubcategories() {
      this.loading = true;
      try {
        const { page, itemsPerPage } = this.pagination;
        const res = await api.get("/category/sub-category", {
          params: {
            category_id: this.$route.params.id,
            page,
            perPage: itemsPerPage,
            filter: this.filter,
          },
        });

        this.subcategories = res.data.data.data;
        this.totalItems = res.data.data.total_records;
      } catch (error) {
        console.error("Failed to load subcategories:", error);
      } finally {
        this.loading = false;
      }
    },
    editSubcategory(item) {
      console.log("Editing subcategory:", item.name);
    },
    deleteSubcategory(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },

    async confirmDelete() {
      try {
        const id = this.selectedItem.id;
        const res = await api.delete(`/category/sub-category/delete/${id}`);
        if (!res.data.status) {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "error",
          });
        } else {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "success",
          });
          this.fetchSubcategories();
        }
      } catch (error) {
        this.$root.$emit("show-snackbar", {
          message: "Failed to delete Sub-Category",
          color: "error",
        });
        console.error("Delete failed:", error);
      }
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>
